import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1579.74 1372.56C1571.95 1511.59 1510.22 1645.24 1423.81 1759.42L1295.76 1664.25C1369.41 1566.93 1414.38 1462.66 1419.93 1363.76C1425.31 1267.7 1394.06 1170.62 1303.19 1080.57L1416.37 968.413C1538.92 1089.85 1587.7 1230.7 1579.74 1372.56Z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1918.78 1399.41C1907.32 1586.09 1816.46 1766.25 1688.4 1920.78L1564.7 1820.12C1679.32 1681.82 1750.25 1532.55 1759.01 1389.78C1767.55 1250.67 1717.81 1108.74 1572.58 977.31L1680.52 860.186C1858.86 1021.59 1930.46 1209.09 1918.78 1399.41Z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.063 159.401H570.008C717.291 159.401 836.779 277.812 836.779 423.865V656.096H838.661V781.847H998.723V423.763C998.723 277.76 1118.16 159.401 1265.49 159.401H1653.98V781.847H1654.16V711.472H1814.04V0.78418H1265.49C1122.04 0.78418 995.116 70.914 917.727 178.464C840.334 70.9225 713.432 0.78418 570.008 0.78418H0V1660.6H330.804V1501.98H160.063V159.401Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.36 885.009L784.214 1113.07H497.901V1659.95H767.889L1014.36 1904.19H1207.57V885.009H1014.36ZM1047.51 1076.48L850.514 1271.69H657.963V1501.33H834.189L1047.51 1712.72V1076.48Z",
  fillRule: "evenodd"
}));

var IconImmersiveReaderSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconImmersiveReaderSolid, _Component);

  var _super = _createSuper(IconImmersiveReaderSolid);

  function IconImmersiveReaderSolid() {
    _classCallCheck(this, IconImmersiveReaderSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconImmersiveReaderSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconImmersiveReader",
        viewBox: "0 0 1920 1921"
      }), _ref);
    }
  }]);

  IconImmersiveReaderSolid.displayName = "IconImmersiveReaderSolid";
  return IconImmersiveReaderSolid;
}(Component);

IconImmersiveReaderSolid.glyphName = 'immersive-reader';
IconImmersiveReaderSolid.variant = 'Solid';
IconImmersiveReaderSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconImmersiveReaderSolid;
export { IconImmersiveReaderSolid };